import { render } from "./ProgramFeeEconomics.vue?vue&type=template&id=c2b77210&scoped=true"
import script from "./ProgramFeeEconomics.vue?vue&type=script&lang=js"
export * from "./ProgramFeeEconomics.vue?vue&type=script&lang=js"

import "./ProgramFeeEconomics.vue?vue&type=style&index=0&id=c2b77210&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b77210"],['__file',"resources/js/components/analytics/ProgramFeeEconomics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2b77210"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2b77210', __exports__)) {
    api.reload('c2b77210', __exports__)
  }
  
  module.hot.accept("./ProgramFeeEconomics.vue?vue&type=template&id=c2b77210&scoped=true", () => {
    api.rerender('c2b77210', render)
  })

}


export default __exports__